import React, { useEffect, useMemo } from 'react';

import { BlockInfoType } from '../../common-types/BlockInfo.type';
import { CollectOptin, ConsentsContainer } from './Consents.style';
import { ConsentConfiguration } from '../../common-types/ScreensConfigurations.type';

export interface Props {
    consentsConfig: ConsentConfiguration[];
    addEditableBlock?: (block: BlockInfoType) => void;
    isEdition?: boolean;
    onBlockEdit?: React.MouseEventHandler<HTMLDivElement>;
    displayName: string;
    dataTemplateConfig: string;
    testId?: string;
    disabled?: boolean;
  }

export const Consents: React.FunctionComponent<Props> = ({
  consentsConfig,
  addEditableBlock,
  isEdition,
  onBlockEdit,
  displayName,
  dataTemplateConfig,
  testId,
  disabled,
} : Props) => {
  const dataTemplateType = 'consents';

  const computedConsents = useMemo(() => {
    return consentsConfig
      .filter(({ activated }) => activated)
      .sort(({ position: positionA }, { position: positionB }) => positionA - positionB);
  }, [consentsConfig]);

  useEffect(
    () => {
      if (addEditableBlock) {
        addEditableBlock({
          blockType: dataTemplateType,
          configPath: dataTemplateConfig,
          label: displayName,
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dataTemplateConfig]
  );

  return (
    <ConsentsContainer
      disabled={disabled}
      isEdition={isEdition}
      data-template-type={dataTemplateType}
      data-display-name={displayName}
      data-config-path={dataTemplateConfig}
      data-testid={testId}
      onClick={onBlockEdit}
    >
      {computedConsents.map(({ type, labelHtml, key }) => {
        switch (type) {
        case 'text':
          return (
            <CollectOptin key={key} dangerouslySetInnerHTML={{ __html: labelHtml }} />
          );
        default:
          return null;
        }
      })}
    </ConsentsContainer>
  );
};
